export default {
  control: (provided) => ({
    ...provided,
    width: "327px",
    background: "#f8f8f8",
    borderColor: "#f8f8f8",
    minHeight: "30px",
    height: "30px",
    boxShadow: null,
    paddingLeft: "10px",
    borderRadius: "5px",
  }),

  valueContainer: (provided) => ({
    ...provided,
    height: "30px",
    padding: "0 6px",
    width: "300px",
  }),

  input: (provided) => ({
    ...provided,
    margin: "0px",
  }),
  indicatorSeparator: () => ({
    display: "none",
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    padding: "6px 8px",
  }),
  clearIndicator: (provided) => ({
    ...provided,
    padding: "6px 8px",
    color: "#dc3545",
    ":hover": {
      color: "#c82333",
    },
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    height: "30px",
  }),
  menu: (provided) => ({
    ...provided,
    zIndex: 2,
  }),
  option: (provided, { isSelected }) => ({
    ...provided,
    "[class*='description']": {
      color: isSelected ? "#fff" : "#8492a6",
    },
  }),
  groupHeading: (provided) => ({
    ...provided,
    color: "#20b2aa",
    fontSize: "0.75rem",
    fontWeight: "600",
    textTransform: "uppercase",
  }),
  singleValue: (provided) => ({
    ...provided,
    borderRadius: "4px",
    display: "flex",
    gap: "6px",
    alignItems: "center",
    fontSize: "15px",
    cursor: "pointer",
    svg: {
      width: "15px",
      fontSize: "14px",
      marginTop: "2px",
    },
  }),
  multiValue: (provided, state) => {
    const selectedOption = state.options.find((o) => o.value === state.data.value);
    return {
      ...provided,
      borderRadius: "4px",
      backgroundColor: selectedOption?.backgroundColor ?? "",
      color: "#fff",
      margin: "0",
    };
  },
  multiValueLabel: (provided) => ({
    ...provided,
    color: "#fff",
    fontSize: "12px",
    // paddingLeft: "8px",
    padding: "0.2rem 0.5rem",
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    fontSize: "14px",
    svg: {
      height: "16px",
      width: "16px",
    },
    ":hover": {
      backgroundColor: "transparent",
    },
  }),
};
